export const MARKER_TYPES = {
  SHOW_NAV: "SHOW_NAV",
  HIDE_NAV: "HIDE_NAV",
  SHOW_SKIP: "SHOW_SKIP",
  HIDE_SKIP: "HIDE_SKIP",
  SIZZLE_START: "SIZZLE_START",
  SIZZLE_END: "SIZZLE_END",
};

export default { MARKER_TYPES };
